import React, { useState, useEffect } from "react";
import styled from "styled-components";
import moment from "moment";
import { getLocale } from "react-i18nify";
import { useSnackbar } from "notistack";
import * as MatStyled from "@mui/material/styles";

import { getSellerProfile, updateSellerProfile } from "src/api/seller";

import { device } from "src/styles/device";
import { decryptData } from "src/components/profile/DecryptData";
import { checkNotEmpty, downloadImage } from "src/common";

import { Grid, useMediaQuery } from "@mui/material";
import TextField from "@mui/material/TextField";

import { Delete, PhotoCameraOutlined } from "@mui/icons-material";
import InsertPhotoIcon from "@mui/icons-material/InsertPhoto";
import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import EditIcon from "@mui/icons-material/Edit";

import ModalFullImage from "src/components/ui/ModalFullImage";
import StyledButton from "src/components/core/Button";
import DropZone from "src/components/core/DropZone";
import { useDialog } from "src/context/DialogContext";
import AddLocationDialog from "../seller/AddLocationDialog";

const DivHeaderProfile = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  width: 100%;
`;

const WrapperImageRow = styled.div`
  display: flex;
  padding: 16px;
  gap: 8px;

  @media (max-width: 768px) {
    flex-direction: column-reverse;
  }
`;

const WrapperImage = styled.div`
  min-width: 120px;
  height: auto;
  object-fit: cover;
  object-position: center;
  margin-right: 16px;
  border-radius: 16px;

  @media (max-width: 768px) {
    margin-right: 0;
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: start;
    gap: 8px;
  }
`;

const PDownloadPdf = styled.p`
  text-align: center;
  font-size: 0.875rem;

  &:hover {
    color: #e43;
    cursor: pointer;
  }
`;

const WrapperOtherImage = styled.div`
  width: 100%;
  height: 220px;
  object-fit: cover;
  object-position: center;
  margin-right: 16px;
  border-radius: 16px;
  @media ${device.tabletL} {
    height: 150px;
  }
  @media ${device.mobile} {
    height: 100px;
  }
`;

const Container = styled.div`
  width: 100%;
  max-width: 1440px;
  position: relative;
  /* padding: 40px 120px 80px; */
  padding: 24px;
  margin: auto;

  & > div > p {
    word-wrap: break-word;
  }

  /* @media ${device.lcd} {
    padding: 40px 60px 80px;
  } */
`;

const DivBackground = styled.div`
  width: 100%;
  padding: 32px;
  background-color: rgb(243, 241, 242);
  box-shadow: rgb(0 0 0 / 16%) 3px 4px 3px;
  border-radius: 30px;
  margin: 16px 0;
`;

const SpanTitle = styled.span`
  color: #000;
  font-size: 1.5rem;
  font-weight: 500;
`;

const SpanHeader = styled.p`
  color: #000;
  font-size: 1rem;
  font-weight: 500;
  margin-bottom: 16px;
`;

const SpanSubHeader = styled.p`
  color: rgb(106 106 109);
  font-size: 0.75rem;
  font-weight: 400;
  margin-bottom: 16px;

  @media (max-width: 768px) {
    text-align: left;
  }
`;

const SpanContent = styled.p`
  color: #000;
  font-size: 1rem;
  font-weight: 400;
  margin-bottom: 16px;
  word-wrap: break-word;

  @media (max-width: 768px) {
    text-align: left;
  }
`;

const SpanContentDesc = styled.p`
  color: #000;
  font-size: 1rem;
  font-weight: 400;
  margin-bottom: 16px;
  min-height: 90px;
  max-height: 150px;
  overflow-y: scroll;
  ::-webkit-scrollbar {
    width: 7px;
    height: 7px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: transparent;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #b9b9b9;
    border-radius: 100px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #b9b9b9;
  }
  ::-webkit-scrollbar-corner {
    background: transparent;
  }

  @media (max-width: 768px) {
    text-align: left;
  }
`;
const ImageEmpty = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  box-shadow: rgb(0 0 0 / 16%) 0px 1px 5px 1px;
  width: 120px;
  height: 120px;
  background: #f2f1f3;
  border-radius: 16px;
  object-fit: cover;
  object-position: center;
  // cursor: pointer;
  vertical-align: initial;
  margin-right: 16px;
  &:hover {
    opacity: 0.8;
  }

  &.active {
    border: 2px solid #707070;
  }
`;

const ImageOtherEmpty = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  box-shadow: rgb(0 0 0 / 16%) 0px 1px 5px 1px;
  width: 100%;
  height: 220px;
  background: #f2f1f3;
  border-radius: 16px;
  object-fit: cover;
  object-position: center;
  // cursor: pointer;
  vertical-align: initial;
  margin-right: 16px;
  &:hover {
    opacity: 0.8;
  }

  &.active {
    border: 2px solid #707070;
  }
  @media ${device.tabletL} {
    height: 150px;
  }
  @media ${device.mobile} {
    height: 100px;
  }
`;

const SpanFullImage = styled.span`
  font-size: 0.625rem;
  margin: 0 0 8px 0;
  display: flex;
  color: #000;
  justify-content: center;
  &:hover {
    cursor: pointer;
    color: #e43;
    text-decoration: underline;
  }
`;

const WrapperTextfield = styled.div`
  width: 100%;
  margin-top: -8px;

  .TextField-without-border-radius fieldset {
    border-radius: 16px;
    // text-align: center;
    // background: #fff;
  }
  .TextField-without-border-radius-amount fieldset {
    border-radius: 16px;
    width: 100%;
    text-align: center;
    background: transparent;
  }
  .MuiAutocomplete-root {
    /* margin: ${({ item }) => (item ? "0" : "24px 0")}; */
    margin: 0;
  }
  .MuiOutlinedInput-input {
    background: #fff;
    border-radius: 16px;
    padding: 10px 14px;
  }
  .MuiInputBase-root-MuiOutlinedInput-root {
    border-radius: 16px;
    background: #fff;
  }
  .MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root {
    border-radius: 16px;
  }

  .MuiTextField-root {
    border-radius: 24px;
  }
  .MuiOutlinedInput-root {
    border-radius: 16px;
    padding: 0;
  }
  .MuiAutocomplete-root .MuiOutlinedInput-root .MuiAutocomplete-input {
    padding: 7.5px 0;
  }
`;

const drawerWidth = 260;

const Main = MatStyled.styled("main", {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  position: "relative",
  flexGrow: 1,
  // padding: theme.spacing(3),
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginLeft: `-${drawerWidth}px`,
  ...(open && {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
    position: "relative",
  }),
}));

const Profile = ({ open }) => {
  const { openDialog, closeDialog, closeAllDialogs } = useDialog();
  const { enqueueSnackbar } = useSnackbar();

  const [profile, setProfile] = useState({});
  const [isEdit, setIsEdit] = useState(false);

  const isSmallerThanTablet = useMediaQuery("(max-width:768px)");

  useEffect(() => {
    fetchProfileData();
  }, [isEdit]);

  const fetchProfileData = async () => {
    try {
      const { data } = await getSellerProfile();
      const decrypt = await decryptData(data);
      // console.log("-----------", decrypt);
      setProfile({
        ...decrypt,
        profile_image: decrypt?.profile_image || "",
        warehouse_image: decrypt?.warehouse_image || "",
        registation: decrypt?.registation || "",
        banner_image: decrypt?.banner_image || "",
        id_card_image: decrypt?.id_card_image || "",
        book_bank_image: decrypt?.book_bank_image || "",
        work_image_first: decrypt?.work_image_first || "",
        work_image_second: decrypt?.work_image_second || "",
        work_image_third: decrypt?.work_image_third || "",
        work_image_fourth: decrypt?.work_image_fourth || "",
        work_image_fifth: decrypt?.work_image_fifth || "",
        work_image_sixth: decrypt?.work_image_sixth || "",
      });
    } catch (err) {
      console.error("err:", err);
    }
  };

  const handleUpdate = () => {
    const data = new FormData();
    Object.keys(profile).map((key) => {
      data.append(key, profile[key]);
      return data;
    });

    updateSellerProfile(data)
      .then((response) => {
        if (response.data === undefined) return;
        enqueueSnackbar(`แก้ไขสำเร็จ`, {
          variant: "success",
        });
        setIsEdit(false);
      })
      .catch((error) => {
        if (error.response?.data === undefined) return;
        enqueueSnackbar(`แก้ไขไม่สำเร็จ`, {
          variant: "error",
        });
        setIsEdit(false);
      });
  };

  const PartnerType = (type) => {
    if (type === 1) {
      return <> {getLocale() === "th" ? "โรงงาน" : "Manufactory"}</>;
    } else if (type === 2) {
      return <> {getLocale() === "th" ? "เจ้าของร้าน" : "Store owner"}</>;
    } else if (type === 3) {
      return <>{getLocale() === "th" ? "ผู้จัดจำหน่าย" : "Distributor"}</>;
    } else if (type === 4) {
      return <>{getLocale() === "th" ? "ร้านค้าปลีก" : "Retailer"}</>;
    } else {
      return <> {getLocale() === "th" ? "ตัวแทนขาย" : "Sale representative"}</>;
    }
  };

  return (
    <Main
      sx={{ marginTop: "75px", background: "#fff", width: "100%" }}
      open={open}
    >
      <Container className="container">
        <DivHeaderProfile>
          <SpanTitle>
            {getLocale() === "th" ? `โปรไฟล์ของผู้ขาย` : "Seller Profile"}
          </SpanTitle>

          <StyledButton
            variant="secondary"
            startIcon={<EditIcon />}
            onClick={() => {
              if (isEdit) {
                openDialog({
                  type: "confirm",
                  title: `คุณต้องการยกเลิกการแก้ไขใช่หรือไม่`,
                  onConfirm: () => {
                    setIsEdit(false);
                    closeDialog();
                  },
                  maxWidth: 342,
                });
              } else {
                setIsEdit(true);
              }
            }}
          >
            {getLocale() === "th" ? "แก้ไขข้อมูล" : "Edit profile"}
          </StyledButton>
        </DivHeaderProfile>

        <Grid container={isSmallerThanTablet ? false : true} spacing={4}>
          <Grid item xs={8}>
            <DivBackground>
              <SpanHeader>
                {getLocale() === "th" ? "บัญชีโปรไฟล์" : "Profile account"}
              </SpanHeader>

              {isEdit ? (
                <>
                  <SpanSubHeader>
                    {getLocale() === "th" ? "ชื่อบริษัท" : "Company name"}
                  </SpanSubHeader>
                  <WrapperTextfield>
                    <TextField
                      variant="outlined"
                      fullWidth
                      value={profile?.company_name || ""}
                      onChange={(e) =>
                        setProfile({
                          ...profile,
                          company_name: e.target.value,
                        })
                      }
                      error={!checkNotEmpty(profile?.company_name)}
                      helperText={
                        !checkNotEmpty(profile?.company_name)
                          ? "โปรดระบุชื่อบริษัท"
                          : ""
                      }
                    />
                  </WrapperTextfield>

                  <SpanSubHeader>
                    {getLocale() === "th" ? "เบอร์โทรศัพท์" : "Phone number"}
                  </SpanSubHeader>
                  <WrapperTextfield>
                    <TextField
                      variant="outlined"
                      fullWidth
                      value={profile?.phone_number || ""}
                      onChange={(e) =>
                        setProfile({
                          ...profile,
                          phone_number: e.target.value,
                        })
                      }
                      error={!checkNotEmpty(profile?.phone_number)}
                      helperText={
                        !checkNotEmpty(profile?.phone_number)
                          ? "โปรดระบุเบอร์โทรศัพท์"
                          : ""
                      }
                    />
                  </WrapperTextfield>

                  <SpanSubHeader>
                    {getLocale() === "th"
                      ? "อีเมลของคุณ"
                      : "Your email address"}
                  </SpanSubHeader>
                  <SpanContent>
                    {profile?.email === "" ||
                    profile?.email === "null" ||
                    profile?.email === null ||
                    profile?.email === undefined
                      ? "-"
                      : profile?.email}
                  </SpanContent>

                  <SpanSubHeader>
                    {getLocale() === "th"
                      ? "ที่อยู่บริษัทของคุณ"
                      : "Your company address"}
                  </SpanSubHeader>
                  <WrapperTextfield>
                    <TextField
                      variant="outlined"
                      fullWidth
                      value={profile?.address || ""}
                      onChange={(e) =>
                        setProfile({
                          ...profile,
                          address: e.target.value,
                        })
                      }
                      error={!checkNotEmpty(profile?.address)}
                      helperText={
                        !checkNotEmpty(profile?.address)
                          ? "โปรดระบุที่อยู่บริษัท"
                          : ""
                      }
                    />
                  </WrapperTextfield>

                  <SpanSubHeader>
                    {getLocale() === "th"
                      ? "เกี่ยวกับบริษัทของคุณ"
                      : "About your company"}
                  </SpanSubHeader>
                  <WrapperTextfield>
                    <TextField
                      variant="outlined"
                      fullWidth
                      multiline
                      rows={3}
                      value={profile?.description || ""}
                      onChange={(e) =>
                        setProfile({
                          ...profile,
                          description: e.target.value,
                        })
                      }
                      error={!checkNotEmpty(profile?.description)}
                      helperText={
                        !checkNotEmpty(profile?.description)
                          ? "โปรดระบุเกี่ยวกับบริษัท"
                          : ""
                      }
                    />
                  </WrapperTextfield>
                </>
              ) : (
                <>
                  <SpanSubHeader>
                    {getLocale() === "th" ? "ชื่อบริษัท" : "Company name"}
                  </SpanSubHeader>
                  <SpanContent>
                    {profile?.company_name === "" ||
                    profile?.company_name === "null" ||
                    profile?.company_name === null
                      ? "-"
                      : profile?.company_name}
                  </SpanContent>

                  <SpanSubHeader>
                    {getLocale() === "th" ? "เบอร์โทรศัพท์" : "Phone number"}
                  </SpanSubHeader>
                  <SpanContent>
                    {profile?.phone_number === "" ||
                    profile?.phone_number === "null" ||
                    profile?.phone_number === null
                      ? "-"
                      : profile?.phone_number}
                  </SpanContent>

                  <SpanSubHeader>
                    {getLocale() === "th"
                      ? "อีเมลของคุณ"
                      : "Your email address"}
                  </SpanSubHeader>
                  <SpanContent>
                    {profile?.email === "" ||
                    profile?.email === "null" ||
                    profile?.email === null ||
                    profile?.email === undefined
                      ? "-"
                      : profile?.email}
                  </SpanContent>

                  <SpanSubHeader>
                    {getLocale() === "th"
                      ? "ที่อยู่บริษัทของคุณ"
                      : "Your company address"}
                  </SpanSubHeader>
                  <SpanContent>
                    {profile?.address === "" ||
                    profile?.address === "null" ||
                    profile?.address === null
                      ? "-"
                      : profile?.address}
                  </SpanContent>

                  <SpanSubHeader>
                    {getLocale() === "th"
                      ? "เกี่ยวกับบริษัทของคุณ"
                      : "About your company"}
                  </SpanSubHeader>
                  <SpanContentDesc>
                    {profile?.description === "" ||
                    profile?.description === "null" ||
                    profile?.description === null
                      ? "-"
                      : profile?.description}
                  </SpanContentDesc>
                </>
              )}

              <SpanSubHeader>
                {getLocale() === "th"
                  ? "ตำแหน่งที่ตั้งบริษัทของคุณ"
                  : "Your company location"}
              </SpanSubHeader>
              <div>
                <StyledButton
                  variant="contained"
                  onClick={() => {
                    openDialog({
                      type: "custom",
                      customDialog: (
                        <AddLocationDialog
                          sellerDetail={profile}
                          onClose={() => closeDialog()}
                          onSuccess={() => {
                            closeAllDialogs();
                            fetchProfileData();
                          }}
                        />
                      ),
                    });
                  }}
                >
                  {getLocale() === "th"
                    ? "จัดการตำแหน่งที่ตั้งบริษัท"
                    : "Manage company location"}
                </StyledButton>
              </div>
            </DivBackground>
          </Grid>

          <Grid
            item
            xs={4}
            sx={{
              margin: "0 auto",
              display: "grid",
              gridTemplateRows: "repeat(3, 1fr)",
            }}
          >
            <DivBackground style={{ height: "185px", marginLeft: "auto" }}>
              <SpanSubHeader>
                {getLocale() === "th" ? "จำนวนสินค้า" : "Product"}
              </SpanSubHeader>
              <SpanContent>{profile?.productCount}</SpanContent>
            </DivBackground>

            <DivBackground style={{ height: "185px", marginLeft: "auto" }}>
              <SpanSubHeader>
                {getLocale() === "th" ? "วันที่เข้าร่วม" : "Join On"}
              </SpanSubHeader>
              <SpanContent>
                {moment(profile?.createdAt).format("L")}
              </SpanContent>
            </DivBackground>

            <DivBackground style={{ height: "185px", marginLeft: "auto" }}>
              <SpanSubHeader>
                {getLocale() === "th" ? "ประเภทธุรกิจ" : "Type of business"}
              </SpanSubHeader>
              <SpanContent>{PartnerType(profile?.seller_type)}</SpanContent>
            </DivBackground>
          </Grid>
        </Grid>

        <Grid container={isSmallerThanTablet ? false : true} spacing={4}>
          <Grid item xs={12} sx={{ margin: "auto" }}>
            <DivBackground>
              <SpanHeader>
                {getLocale() === "th" ? "บัญชีโปรไฟล์" : "Profile account"}
              </SpanHeader>

              {isEdit ? (
                <>
                  <WrapperImageRow>
                    {/* This is just a quick component for uploading icon homepage images, 
                    it should be improved if we have to deal with this again in the future. 
                    tarit Sep 9 2024 */}
                    {!checkNotEmpty(profile?.icon_homepage) ? (
                      <DropZone
                        onDrop={(files) => {
                          setProfile({
                            ...profile,
                            icon_homepage: files[0],
                          });
                        }}
                        accept=".jpg, .jpeg, .png, .webp"
                      >
                        {(props) => {
                          return (
                            <ImageEmpty
                              style={{
                                marginLeft: 0,
                                width: 160,
                                height: 80,
                                userSelect: "none",
                                cursor: "pointer",
                              }}
                              {...props}
                            >
                              <PhotoCameraOutlined
                                sx={{
                                  color: "#BCBCC0",
                                  mr: 1,
                                }}
                              />
                              <span
                                style={{
                                  fontSize: "0.65rem",
                                  color: "#6C6C70",
                                }}
                              >
                                อัพโหลดรูปภาพ
                              </span>
                            </ImageEmpty>
                          );
                        }}
                      </DropZone>
                    ) : (
                      <WrapperImage>
                        <div
                          style={{
                            position: "relative",
                            width: 160,
                            height: 80,
                            borderRadius: "16px",
                            overflow: "hidden",
                            marginBottom: "8px",
                          }}
                        >
                          <img
                            src={
                              typeof profile?.icon_homepage === "string"
                                ? profile?.icon_homepage
                                : URL.createObjectURL(profile?.icon_homepage)
                            }
                            alt="icon homepage"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                          />
                          <div
                            style={{
                              position: "absolute",
                              top: "10px",
                              right: "10px",
                              cursor: "pointer",
                            }}
                          >
                            <Delete
                              onClick={(e) => {
                                setProfile({
                                  ...profile,
                                  icon_homepage: "",
                                });
                              }}
                              sx={{
                                background: "#fff",
                                borderRadius: "100%",
                                color: "#e04132",
                                padding: "3px",
                              }}
                            />
                          </div>
                        </div>
                      </WrapperImage>
                    )}
                    <div>
                      <SpanSubHeader>
                        {getLocale() === "th"
                          ? "รูปภาพเกี่ยวกับคุณ"
                          : "Your Image"}
                      </SpanSubHeader>
                      <SpanContent>
                        {getLocale() === "th"
                          ? "รูปภาพไอค่อนหน้าเว็บไซต์"
                          : "Image of icon homepage"}
                      </SpanContent>
                    </div>
                  </WrapperImageRow>

                  <WrapperImageRow>
                    {!checkNotEmpty(profile?.profile_image) ? (
                      <DropZone
                        onDrop={(files) => {
                          setProfile({
                            ...profile,
                            profile_image: files[0],
                          });
                        }}
                        accept=".jpg, .jpeg, .png, .webp"
                      >
                        {(props) => {
                          return (
                            <ImageEmpty
                              style={{
                                marginLeft: 0,
                                width: 120,
                                height: 120,
                                userSelect: "none",
                                cursor: "pointer",
                                flexDirection: "column",
                              }}
                              {...props}
                            >
                              <PhotoCameraOutlined
                                sx={{
                                  color: "#BCBCC0",
                                  mr: 1,
                                }}
                              />
                              <span
                                style={{
                                  fontSize: "0.65rem",
                                  color: "#6C6C70",
                                }}
                              >
                                อัพโหลดรูปภาพ
                              </span>
                            </ImageEmpty>
                          );
                        }}
                      </DropZone>
                    ) : (
                      <WrapperImage>
                        <div
                          style={{
                            position: "relative",
                            width: 120,
                            height: 120,
                            borderRadius: "16px",
                            overflow: "hidden",
                            marginBottom: "8px",
                          }}
                        >
                          <img
                            src={
                              typeof profile?.profile_image === "string"
                                ? profile?.profile_image
                                : URL.createObjectURL(profile?.profile_image)
                            }
                            alt="profile_image"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                          />
                          <div
                            style={{
                              position: "absolute",
                              top: "10px",
                              right: "10px",
                              cursor: "pointer",
                            }}
                          >
                            <Delete
                              onClick={(e) => {
                                setProfile({
                                  ...profile,
                                  profile_image: "",
                                });
                              }}
                              sx={{
                                background: "#fff",
                                borderRadius: "100%",
                                color: "#e04132",
                                padding: "3px",
                              }}
                            />
                          </div>
                        </div>
                      </WrapperImage>
                    )}

                    <div>
                      <SpanSubHeader>
                        {getLocale() === "th"
                          ? "รูปภาพเกี่ยวกับคุณ"
                          : "Your Image"}
                      </SpanSubHeader>
                      <SpanContent>
                        {getLocale() === "th"
                          ? "รูปภาพโลโก้ร้านค้า"
                          : "Image of store or logo"}
                      </SpanContent>
                    </div>
                  </WrapperImageRow>

                  <WrapperImageRow>
                    {!checkNotEmpty(profile?.id_card_image) ? (
                      <DropZone
                        onDrop={(files) => {
                          setProfile({
                            ...profile,
                            id_card_image: files[0],
                          });
                        }}
                        accept=".jpg, .jpeg, .png, .webp"
                      >
                        {(props) => {
                          return (
                            <ImageEmpty
                              style={{
                                marginLeft: 0,
                                width: 120,
                                height: 120,
                                userSelect: "none",
                                cursor: "pointer",
                                flexDirection: "column",
                              }}
                              {...props}
                            >
                              <PhotoCameraOutlined
                                sx={{
                                  color: "#BCBCC0",
                                  mr: 1,
                                }}
                              />
                              <span
                                style={{
                                  fontSize: "0.65rem",
                                  color: "#6C6C70",
                                }}
                              >
                                อัพโหลดรูปภาพ
                              </span>
                            </ImageEmpty>
                          );
                        }}
                      </DropZone>
                    ) : (
                      <WrapperImage>
                        <div
                          style={{
                            position: "relative",
                            width: 120,
                            height: 120,
                            borderRadius: "16px",
                            overflow: "hidden",
                            marginBottom: "8px",
                          }}
                        >
                          <img
                            src={
                              typeof profile?.id_card_image === "string"
                                ? profile?.id_card_image
                                : URL.createObjectURL(profile?.id_card_image)
                            }
                            alt="id_card_image"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                          />
                          <div
                            style={{
                              position: "absolute",
                              top: "10px",
                              right: "10px",
                              cursor: "pointer",
                            }}
                          >
                            <Delete
                              onClick={(e) => {
                                setProfile({
                                  ...profile,
                                  id_card_image: "",
                                });
                              }}
                              sx={{
                                background: "#fff",
                                borderRadius: "100%",
                                color: "#e04132",
                                padding: "3px",
                              }}
                            />
                          </div>
                        </div>
                      </WrapperImage>
                    )}

                    <div>
                      <SpanSubHeader>
                        {getLocale() === "th"
                          ? "รูปภาพเกี่ยวกับคุณ"
                          : "Your Image"}
                      </SpanSubHeader>
                      <SpanContent>
                        {getLocale() === "th"
                          ? "รูปภาพสำเนาใบทะเบียนภาษีมูลค่าเพิ่ม​ (ภ.พ.20) หรือ สำเนาบัตรประชาชน"
                          : "A copy of company registration or ID card"}
                      </SpanContent>
                    </div>
                  </WrapperImageRow>

                  <WrapperImageRow>
                    {!checkNotEmpty(profile?.warehouse_image) ? (
                      <DropZone
                        onDrop={(files) => {
                          setProfile({
                            ...profile,
                            warehouse_image: files[0],
                          });
                        }}
                        accept=".jpg, .jpeg, .png, .webp"
                      >
                        {(props) => {
                          return (
                            <ImageEmpty
                              style={{
                                marginLeft: 0,
                                width: 120,
                                height: 120,
                                userSelect: "none",
                                cursor: "pointer",
                                flexDirection: "column",
                              }}
                              {...props}
                            >
                              <PhotoCameraOutlined
                                sx={{
                                  color: "#BCBCC0",
                                  mr: 1,
                                }}
                              />
                              <span
                                style={{
                                  fontSize: "0.65rem",
                                  color: "#6C6C70",
                                }}
                              >
                                อัพโหลดรูปภาพ
                              </span>
                            </ImageEmpty>
                          );
                        }}
                      </DropZone>
                    ) : (
                      <WrapperImage>
                        <div
                          style={{
                            position: "relative",
                            width: 120,
                            height: 120,
                            borderRadius: "16px",
                            overflow: "hidden",
                            marginBottom: "8px",
                          }}
                        >
                          <img
                            src={
                              typeof profile?.warehouse_image === "string"
                                ? profile?.warehouse_image
                                : URL.createObjectURL(profile?.warehouse_image)
                            }
                            alt="warehouse_image"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                          />
                          <div
                            style={{
                              position: "absolute",
                              top: "10px",
                              right: "10px",
                              cursor: "pointer",
                            }}
                          >
                            <Delete
                              onClick={(e) => {
                                setProfile({
                                  ...profile,
                                  warehouse_image: "",
                                });
                              }}
                              sx={{
                                background: "#fff",
                                borderRadius: "100%",
                                color: "#e04132",
                                padding: "3px",
                              }}
                            />
                          </div>
                        </div>
                      </WrapperImage>
                    )}

                    <div>
                      <SpanSubHeader>
                        {getLocale() === "th"
                          ? "รูปภาพเกี่ยวกับคุณ"
                          : "Your Image"}
                      </SpanSubHeader>
                      <SpanContent>
                        {getLocale() === "th"
                          ? "รูปภาพหน้าร้านค้า หรือภาพสินค้าที่เกี่ยวข้องเพื่อยืนยันตัวตน"
                          : "A photo of company, factory or store front in order to verify"}
                      </SpanContent>
                    </div>
                  </WrapperImageRow>

                  <WrapperImageRow>
                    {!checkNotEmpty(profile?.book_bank_image) ? (
                      <DropZone
                        onDrop={(files) => {
                          setProfile({
                            ...profile,
                            book_bank_image: files[0],
                          });
                        }}
                        accept=".jpg, .jpeg, .png, .webp"
                      >
                        {(props) => {
                          return (
                            <ImageEmpty
                              style={{
                                marginLeft: 0,
                                width: 120,
                                height: 120,
                                userSelect: "none",
                                cursor: "pointer",
                                flexDirection: "column",
                              }}
                              {...props}
                            >
                              <PhotoCameraOutlined
                                sx={{
                                  color: "#BCBCC0",
                                  cursor: "pointer",
                                }}
                              />
                              <span
                                style={{
                                  fontSize: "0.65rem",
                                  color: "#6C6C70",
                                }}
                              >
                                อัพโหลดรูปภาพ
                              </span>
                            </ImageEmpty>
                          );
                        }}
                      </DropZone>
                    ) : (
                      <WrapperImage>
                        <div
                          style={{
                            position: "relative",
                            width: 120,
                            height: 120,
                            borderRadius: "16px",
                            overflow: "hidden",
                            marginBottom: "8px",
                          }}
                        >
                          <img
                            src={
                              typeof profile?.book_bank_image === "string"
                                ? profile?.book_bank_image
                                : URL.createObjectURL(profile?.book_bank_image)
                            }
                            alt="icon homepage"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                          />
                          <div
                            style={{
                              position: "absolute",
                              top: "10px",
                              right: "10px",
                              cursor: "pointer",
                            }}
                          >
                            <Delete
                              onClick={(e) => {
                                setProfile({
                                  ...profile,
                                  book_bank_image: "",
                                });
                              }}
                              sx={{
                                background: "#fff",
                                borderRadius: "100%",
                                color: "#e04132",
                                padding: "3px",
                              }}
                            />
                          </div>
                        </div>
                      </WrapperImage>
                    )}
                    <div>
                      <SpanSubHeader>
                        {getLocale() === "th"
                          ? "รูปภาพเกี่ยวกับคุณ"
                          : "Your Image"}
                      </SpanSubHeader>
                      <SpanContent>
                        {getLocale() === "th"
                          ? "รูปภาพสมุดบัญชี"
                          : "Image of book bank"}
                      </SpanContent>
                    </div>
                  </WrapperImageRow>

                  <WrapperImageRow>
                    {!checkNotEmpty(profile?.registation) ? (
                      <DropZone
                        onDrop={(files) => {
                          setProfile({
                            ...profile,
                            registation: files[0],
                          });
                        }}
                        accept=".pdf"
                      >
                        {(props) => {
                          return (
                            <ImageEmpty
                              style={{
                                marginLeft: 0,
                                width: 120,
                                height: 120,
                                userSelect: "none",
                                cursor: "pointer",
                                flexDirection: "column",
                              }}
                              {...props}
                            >
                              <PhotoCameraOutlined
                                sx={{
                                  color: "#BCBCC0",
                                  cursor: "pointer",
                                }}
                              />
                              <span
                                style={{
                                  fontSize: "0.65rem",
                                  color: "#6C6C70",
                                }}
                              >
                                อัพโหลดเอกสาร
                              </span>
                            </ImageEmpty>
                          );
                        }}
                      </DropZone>
                    ) : (
                      <>
                        <WrapperImage>
                          <div
                            style={{
                              position: "relative",
                              width: 120,
                              height: 120,
                              borderRadius: "16px",
                              overflow: "hidden",
                              marginBottom: "8px",
                            }}
                          >
                            <TextSnippetIcon
                              sx={{
                                width: "40px",
                                height: "100%",
                                display: "flex",
                                justifyContent: "center",
                                margin: isSmallerThanTablet ? 0 : "auto",
                                alignContent: "center",
                                alignItems: "center",
                              }}
                            />
                            <div
                              style={{
                                position: "absolute",
                                top: "10px",
                                right: "10px",
                                cursor: "pointer",
                              }}
                            >
                              <Delete
                                onClick={(e) => {
                                  setProfile({
                                    ...profile,
                                    registation: "",
                                  });
                                }}
                                sx={{
                                  background: "#fff",
                                  borderRadius: "100%",
                                  color: "#e04132",
                                  padding: "3px",
                                }}
                              />
                            </div>
                          </div>
                        </WrapperImage>
                      </>
                    )}

                    <div>
                      <SpanSubHeader>
                        {getLocale() === "th"
                          ? "รูปภาพเกี่ยวกับคุณ"
                          : "Your Image"}
                      </SpanSubHeader>
                      <SpanContent>
                        {getLocale() === "th"
                          ? "เอกสารสำเนาเกี่ยวข้องกับร้านค้า"
                          : "Copy of documents related to the store"}
                      </SpanContent>
                    </div>
                  </WrapperImageRow>
                </>
              ) : (
                <>
                  <WrapperImageRow>
                    {!profile?.icon_homepage ? (
                      <ImageEmpty
                        style={{
                          marginLeft: 0,
                          width: 160,
                          height: 80,
                          userSelect: "none",
                        }}
                      >
                        <InsertPhotoIcon
                          sx={{
                            color: "rgba(0, 0, 0, 0.54)",
                            width: "35%",
                            height: "35%",
                          }}
                        />
                      </ImageEmpty>
                    ) : (
                      <WrapperImage>
                        <div
                          style={{
                            position: "relative",
                            width: 160,
                            height: 80,
                            borderRadius: "16px",
                            overflow: "hidden",
                            marginBottom: "8px",
                          }}
                        >
                          <img
                            src={
                              typeof profile?.icon_homepage === "string"
                                ? profile?.icon_homepage
                                : URL.createObjectURL(profile?.icon_homepage)
                            }
                            alt="icon homepage"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                          />
                        </div>

                        {typeof profile?.icon_homepage === "string" && (
                          <SpanFullImage
                            onClick={() => {
                              openDialog({
                                type: "custom",
                                customDialog: (
                                  <ModalFullImage
                                    image={profile?.icon_homepage}
                                    close={(disp) => closeAllDialogs()}
                                  />
                                ),
                              });
                            }}
                          >
                            คลิกเพิ่มเติมเพื่อดูรูปเต็ม
                          </SpanFullImage>
                        )}
                      </WrapperImage>
                    )}
                    <div>
                      <SpanSubHeader>
                        {getLocale() === "th"
                          ? "รูปภาพเกี่ยวกับคุณ"
                          : "Your Image"}
                      </SpanSubHeader>
                      <SpanContent>
                        {getLocale() === "th"
                          ? "รูปภาพไอค่อนหน้าเว็บไซต์"
                          : "Image of icon homepage"}
                      </SpanContent>
                    </div>
                  </WrapperImageRow>

                  <WrapperImageRow>
                    {!checkNotEmpty(profile?.profile_image) ? (
                      <ImageEmpty>
                        <InsertPhotoIcon
                          sx={{
                            color: "rgba(0, 0, 0, 0.54)",
                            width: "25%",
                            height: "25%",
                          }}
                        />
                      </ImageEmpty>
                    ) : (
                      <>
                        <WrapperImage>
                          <img
                            src={profile?.profile_image}
                            alt={profile?.profile_image}
                            style={{
                              width: "120px",
                              height: "120px",
                              borderRadius: "16px",
                              objectFit: "cover",
                            }}
                          />
                          <SpanFullImage
                            onClick={() => {
                              openDialog({
                                type: "custom",
                                customDialog: (
                                  <ModalFullImage
                                    image={profile?.profile_image}
                                    close={(disp) => closeAllDialogs()}
                                  />
                                ),
                              });
                            }}
                          >
                            คลิกเพิ่มเติมเพื่อดูรูปเต็ม
                          </SpanFullImage>
                        </WrapperImage>
                      </>
                    )}

                    <div>
                      <SpanSubHeader>
                        {getLocale() === "th"
                          ? "รูปภาพเกี่ยวกับคุณ"
                          : "Your Image"}
                      </SpanSubHeader>
                      <SpanContent>
                        {getLocale() === "th"
                          ? "รูปภาพโลโก้ร้านค้า"
                          : "Image of store or logo"}
                      </SpanContent>
                    </div>
                  </WrapperImageRow>

                  <WrapperImageRow>
                    {!checkNotEmpty(profile?.id_card_image) ? (
                      <ImageEmpty>
                        <InsertPhotoIcon
                          sx={{
                            color: "rgba(0, 0, 0, 0.54)",
                            width: "25%",
                            height: "25%",
                          }}
                        />
                      </ImageEmpty>
                    ) : (
                      <>
                        <WrapperImage>
                          <img
                            src={profile?.id_card_image}
                            alt={profile?.id_card_image}
                            style={{
                              width: "120px",
                              height: "120px",
                              borderRadius: "16px",
                              objectFit: "cover",
                            }}
                          />
                          <SpanFullImage
                            onClick={() => {
                              openDialog({
                                type: "custom",
                                customDialog: (
                                  <ModalFullImage
                                    image={profile?.id_card_image}
                                    close={(disp) => closeAllDialogs()}
                                  />
                                ),
                              });
                            }}
                          >
                            คลิกเพิ่มเติมเพื่อดูรูปเต็ม
                          </SpanFullImage>
                        </WrapperImage>
                      </>
                    )}

                    <div>
                      <SpanSubHeader>
                        {getLocale() === "th"
                          ? "รูปภาพเกี่ยวกับคุณ"
                          : "Your Image"}
                      </SpanSubHeader>
                      <SpanContent>
                        {getLocale() === "th"
                          ? "รูปภาพสำเนาใบทะเบียนภาษีมูลค่าเพิ่ม​ (ภ.พ.20) หรือ สำเนาบัตรประชาชน"
                          : "A copy of company registration or ID card"}
                      </SpanContent>
                    </div>
                  </WrapperImageRow>

                  <WrapperImageRow>
                    {!checkNotEmpty(profile?.warehouse_image) ? (
                      <ImageEmpty>
                        <InsertPhotoIcon
                          sx={{
                            color: "rgba(0, 0, 0, 0.54)",
                            width: "25%",
                            height: "25%",
                          }}
                        />
                      </ImageEmpty>
                    ) : (
                      <>
                        <WrapperImage>
                          <img
                            src={profile?.warehouse_image}
                            alt=""
                            style={{
                              width: "120px",
                              height: "120px",
                              borderRadius: "16px",
                              objectFit: "cover",
                            }}
                          />
                          <SpanFullImage
                            onClick={() => {
                              openDialog({
                                type: "custom",
                                customDialog: (
                                  <ModalFullImage
                                    image={profile?.warehouse_image}
                                    close={(disp) => closeAllDialogs()}
                                  />
                                ),
                              });
                            }}
                          >
                            คลิกเพิ่มเติมเพื่อดูรูปเต็ม
                          </SpanFullImage>
                        </WrapperImage>
                      </>
                    )}

                    <div>
                      <SpanSubHeader>
                        {getLocale() === "th"
                          ? "รูปภาพเกี่ยวกับคุณ"
                          : "Your Image"}
                      </SpanSubHeader>
                      <SpanContent>
                        {getLocale() === "th"
                          ? "รูปภาพหน้าร้านค้า หรือภาพสินค้าที่เกี่ยวข้องเพื่อยืนยันตัวตน"
                          : "A photo of company, factory or store front in order to verify"}
                      </SpanContent>
                    </div>
                  </WrapperImageRow>

                  <WrapperImageRow>
                    {!checkNotEmpty(profile?.book_bank_image) ? (
                      <ImageEmpty>
                        <InsertPhotoIcon
                          sx={{
                            color: "rgba(0, 0, 0, 0.54)",
                            width: "25%",
                            height: "25%",
                          }}
                        />
                      </ImageEmpty>
                    ) : (
                      <WrapperImage>
                        <div
                          style={{
                            position: "relative",
                            width: 120,
                            height: 120,
                            borderRadius: "16px",
                            overflow: "hidden",
                            marginBottom: "8px",
                          }}
                        >
                          <img
                            src={
                              typeof profile?.book_bank_image === "string"
                                ? profile?.book_bank_image
                                : URL.createObjectURL(profile?.book_bank_image)
                            }
                            alt="icon homepage"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                          />
                        </div>
                        {typeof profile?.book_bank_image === "string" && (
                          <SpanFullImage
                            onClick={() => {
                              openDialog({
                                type: "custom",
                                customDialog: (
                                  <ModalFullImage
                                    image={profile?.book_bank_image}
                                    close={(disp) => closeAllDialogs()}
                                  />
                                ),
                              });
                            }}
                          >
                            คลิกเพิ่มเติมเพื่อดูรูปเต็ม
                          </SpanFullImage>
                        )}
                      </WrapperImage>
                    )}

                    <div>
                      <SpanSubHeader>
                        {getLocale() === "th"
                          ? "รูปภาพเกี่ยวกับคุณ"
                          : "Your Image"}
                      </SpanSubHeader>
                      <SpanContent>
                        {getLocale() === "th"
                          ? "รูปภาพสมุดบัญชี"
                          : "Image of book bank"}
                      </SpanContent>
                    </div>
                  </WrapperImageRow>

                  <WrapperImageRow>
                    {!checkNotEmpty(profile?.registation) ? (
                      <ImageEmpty>
                        <InsertPhotoIcon
                          sx={{
                            color: "rgba(0, 0, 0, 0.54)",
                            width: "25%",
                            height: "25%",
                          }}
                        />
                      </ImageEmpty>
                    ) : (
                      <>
                        <WrapperImage>
                          <TextSnippetIcon
                            sx={{
                              width: "40px",
                              height: "120px",
                              display: "flex",
                              justifyContent: "center",
                              margin: isSmallerThanTablet ? 0 : "auto",
                              alignContent: "center",
                              alignItems: "center",
                            }}
                          />
                          <PDownloadPdf
                            onClick={() => {
                              // window.open(`${profile?.registation}`, "_blank");
                              downloadImage(`${profile?.registation}`, "pdf");
                            }}
                          >
                            Download PDF
                          </PDownloadPdf>
                        </WrapperImage>
                      </>
                    )}

                    <div>
                      <SpanSubHeader>
                        {getLocale() === "th"
                          ? "รูปภาพเกี่ยวกับคุณ"
                          : "Your Image"}
                      </SpanSubHeader>
                      <SpanContent>
                        {getLocale() === "th"
                          ? "เอกสารสำเนาเกี่ยวข้องกับร้านค้า"
                          : "Copy of documents related to the store"}
                      </SpanContent>
                    </div>
                  </WrapperImageRow>
                </>
              )}
            </DivBackground>
          </Grid>
        </Grid>

        <Grid container={isSmallerThanTablet ? false : true} spacing={4}>
          <Grid item xs={12} sx={{ margin: "auto" }}>
            <DivBackground>
              <SpanHeader>
                {getLocale() === "th" ? "รูปภาพอื่นๆ" : "More Image"}
              </SpanHeader>

              {isEdit ? (
                <>
                  <Grid container spacing={2} sx={{ marginBottom: "24px" }}>
                    <Grid item xs={6}>
                      {!checkNotEmpty(profile?.banner_image) ? (
                        <DropZone
                          onDrop={(files) => {
                            setProfile({
                              ...profile,
                              banner_image: files[0],
                            });
                          }}
                          accept=".jpg, .jpeg, .png, .webp"
                        >
                          {(props) => {
                            return (
                              <ImageOtherEmpty
                                style={{
                                  userSelect: "none",
                                  cursor: "pointer",
                                  flexDirection: "column",
                                }}
                                {...props}
                              >
                                <InsertPhotoIcon
                                  sx={{
                                    color: "#BCBCC0",
                                    width: "25%",
                                    height: "25%",
                                  }}
                                />
                                <span
                                  style={{
                                    fontSize: "0.65rem",
                                    color: "#6C6C70",
                                  }}
                                >
                                  อัพโหลดรูปภาพ
                                </span>
                              </ImageOtherEmpty>
                            );
                          }}
                        </DropZone>
                      ) : (
                        <>
                          <WrapperOtherImage>
                            <div
                              style={{
                                position: "relative",
                                width: "100%",
                                height: "100%",
                                borderRadius: "16px",
                                overflow: "hidden",
                                marginBottom: "8px",
                              }}
                            >
                              <img
                                src={
                                  typeof profile?.banner_image === "string"
                                    ? profile?.banner_image
                                    : URL.createObjectURL(profile?.banner_image)
                                }
                                alt="banner_image"
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  borderRadius: "16px",
                                  objectFit: "cover",
                                }}
                              />
                              <div
                                style={{
                                  position: "absolute",
                                  top: "10px",
                                  right: "10px",
                                  cursor: "pointer",
                                }}
                              >
                                <Delete
                                  onClick={(e) => {
                                    setProfile({
                                      ...profile,
                                      banner_image: "",
                                    });
                                  }}
                                  sx={{
                                    background: "#fff",
                                    borderRadius: "100%",
                                    color: "#e04132",
                                    padding: "3px",
                                  }}
                                />
                              </div>
                            </div>
                          </WrapperOtherImage>
                        </>
                      )}
                    </Grid>

                    <Grid item xs={6}>
                      {!checkNotEmpty(profile?.work_image_first) ? (
                        <DropZone
                          onDrop={(files) => {
                            setProfile({
                              ...profile,
                              work_image_first: files[0],
                            });
                          }}
                          accept=".jpg, .jpeg, .png, .webp"
                        >
                          {(props) => {
                            return (
                              <ImageOtherEmpty
                                style={{
                                  userSelect: "none",
                                  cursor: "pointer",
                                  flexDirection: "column",
                                }}
                                {...props}
                              >
                                <InsertPhotoIcon
                                  sx={{
                                    color: "#BCBCC0",
                                    width: "25%",
                                    height: "25%",
                                  }}
                                />
                                <span
                                  style={{
                                    fontSize: "0.65rem",
                                    color: "#6C6C70",
                                  }}
                                >
                                  อัพโหลดรูปภาพ
                                </span>
                              </ImageOtherEmpty>
                            );
                          }}
                        </DropZone>
                      ) : (
                        <>
                          <WrapperOtherImage>
                            <div
                              style={{
                                position: "relative",
                                width: "100%",
                                height: "100%",
                                borderRadius: "16px",
                                overflow: "hidden",
                                marginBottom: "8px",
                              }}
                            >
                              <img
                                src={
                                  typeof profile?.work_image_first === "string"
                                    ? profile?.work_image_first
                                    : URL.createObjectURL(
                                        profile?.work_image_first,
                                      )
                                }
                                alt="work_image_first"
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  borderRadius: "16px",
                                  objectFit: "cover",
                                }}
                              />
                              <div
                                style={{
                                  position: "absolute",
                                  top: "10px",
                                  right: "10px",
                                  cursor: "pointer",
                                }}
                              >
                                <Delete
                                  onClick={(e) => {
                                    setProfile({
                                      ...profile,
                                      work_image_first: "",
                                    });
                                  }}
                                  sx={{
                                    background: "#fff",
                                    borderRadius: "100%",
                                    color: "#e04132",
                                    padding: "3px",
                                  }}
                                />
                              </div>
                            </div>
                          </WrapperOtherImage>
                        </>
                      )}
                    </Grid>
                  </Grid>

                  <Grid container spacing={2} sx={{ marginBottom: "24px" }}>
                    <Grid item xs={6}>
                      {!checkNotEmpty(profile?.work_image_second) ? (
                        <DropZone
                          onDrop={(files) => {
                            setProfile({
                              ...profile,
                              work_image_second: files[0],
                            });
                          }}
                          accept=".jpg, .jpeg, .png, .webp"
                        >
                          {(props) => {
                            return (
                              <ImageOtherEmpty
                                style={{
                                  userSelect: "none",
                                  cursor: "pointer",
                                  flexDirection: "column",
                                }}
                                {...props}
                              >
                                <InsertPhotoIcon
                                  sx={{
                                    color: "#BCBCC0",
                                    width: "25%",
                                    height: "25%",
                                  }}
                                />
                                <span
                                  style={{
                                    fontSize: "0.65rem",
                                    color: "#6C6C70",
                                  }}
                                >
                                  อัพโหลดรูปภาพ
                                </span>
                              </ImageOtherEmpty>
                            );
                          }}
                        </DropZone>
                      ) : (
                        <>
                          <WrapperOtherImage>
                            <div
                              style={{
                                position: "relative",
                                width: "100%",
                                height: "100%",
                                borderRadius: "16px",
                                overflow: "hidden",
                                marginBottom: "8px",
                              }}
                            >
                              <img
                                src={
                                  typeof profile?.work_image_second === "string"
                                    ? profile?.work_image_second
                                    : URL.createObjectURL(
                                        profile?.work_image_second,
                                      )
                                }
                                alt="work_image_second"
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  borderRadius: "16px",
                                  objectFit: "cover",
                                }}
                              />
                              <div
                                style={{
                                  position: "absolute",
                                  top: "10px",
                                  right: "10px",
                                  cursor: "pointer",
                                }}
                              >
                                <Delete
                                  onClick={(e) => {
                                    setProfile({
                                      ...profile,
                                      work_image_second: "",
                                    });
                                  }}
                                  sx={{
                                    background: "#fff",
                                    borderRadius: "100%",
                                    color: "#e04132",
                                    padding: "3px",
                                  }}
                                />
                              </div>
                            </div>
                          </WrapperOtherImage>
                        </>
                      )}
                    </Grid>

                    <Grid item xs={6}>
                      {!checkNotEmpty(profile?.work_image_third) ? (
                        <DropZone
                          onDrop={(files) => {
                            setProfile({
                              ...profile,
                              work_image_third: files[0],
                            });
                          }}
                          accept=".jpg, .jpeg, .png, .webp"
                        >
                          {(props) => {
                            return (
                              <ImageOtherEmpty
                                style={{
                                  userSelect: "none",
                                  cursor: "pointer",
                                  flexDirection: "column",
                                }}
                                {...props}
                              >
                                <InsertPhotoIcon
                                  sx={{
                                    color: "#BCBCC0",
                                    width: "25%",
                                    height: "25%",
                                  }}
                                />
                                <span
                                  style={{
                                    fontSize: "0.65rem",
                                    color: "#6C6C70",
                                  }}
                                >
                                  อัพโหลดรูปภาพ
                                </span>
                              </ImageOtherEmpty>
                            );
                          }}
                        </DropZone>
                      ) : (
                        <>
                          <WrapperOtherImage>
                            <div
                              style={{
                                position: "relative",
                                width: "100%",
                                height: "100%",
                                borderRadius: "16px",
                                overflow: "hidden",
                                marginBottom: "8px",
                              }}
                            >
                              <img
                                src={
                                  typeof profile?.work_image_third === "string"
                                    ? profile?.work_image_third
                                    : URL.createObjectURL(
                                        profile?.work_image_third,
                                      )
                                }
                                alt="work_image_third"
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  borderRadius: "16px",
                                  objectFit: "cover",
                                }}
                              />
                              <div
                                style={{
                                  position: "absolute",
                                  top: "10px",
                                  right: "10px",
                                  cursor: "pointer",
                                }}
                              >
                                <Delete
                                  onClick={(e) => {
                                    setProfile({
                                      ...profile,
                                      work_image_third: "",
                                    });
                                  }}
                                  sx={{
                                    background: "#fff",
                                    borderRadius: "100%",
                                    color: "#e04132",
                                    padding: "3px",
                                  }}
                                />
                              </div>
                            </div>
                          </WrapperOtherImage>
                        </>
                      )}
                    </Grid>
                  </Grid>

                  <Grid container spacing={2} sx={{ marginBottom: "24px" }}>
                    <Grid item xs={4}>
                      {!checkNotEmpty(profile?.work_image_fourth) ? (
                        <DropZone
                          onDrop={(files) => {
                            setProfile({
                              ...profile,
                              work_image_fourth: files[0],
                            });
                          }}
                          accept=".jpg, .jpeg, .png, .webp"
                        >
                          {(props) => {
                            return (
                              <ImageOtherEmpty
                                style={{
                                  userSelect: "none",
                                  cursor: "pointer",
                                  flexDirection: "column",
                                }}
                                {...props}
                              >
                                <InsertPhotoIcon
                                  sx={{
                                    color: "#BCBCC0",
                                    width: "25%",
                                    height: "25%",
                                  }}
                                />
                                <span
                                  style={{
                                    fontSize: "0.65rem",
                                    color: "#6C6C70",
                                  }}
                                >
                                  อัพโหลดรูปภาพ
                                </span>
                              </ImageOtherEmpty>
                            );
                          }}
                        </DropZone>
                      ) : (
                        <>
                          <WrapperOtherImage>
                            <div
                              style={{
                                position: "relative",
                                width: "100%",
                                height: "100%",
                                borderRadius: "16px",
                                overflow: "hidden",
                                marginBottom: "8px",
                              }}
                            >
                              <img
                                src={
                                  typeof profile?.work_image_fourth === "string"
                                    ? profile?.work_image_fourth
                                    : URL.createObjectURL(
                                        profile?.work_image_fourth,
                                      )
                                }
                                alt="work_image_fourth"
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  borderRadius: "16px",
                                  objectFit: "cover",
                                }}
                              />
                              <div
                                style={{
                                  position: "absolute",
                                  top: "10px",
                                  right: "10px",
                                  cursor: "pointer",
                                }}
                              >
                                <Delete
                                  onClick={(e) => {
                                    setProfile({
                                      ...profile,
                                      work_image_fourth: "",
                                    });
                                  }}
                                  sx={{
                                    background: "#fff",
                                    borderRadius: "100%",
                                    color: "#e04132",
                                    padding: "3px",
                                  }}
                                />
                              </div>
                            </div>
                          </WrapperOtherImage>
                        </>
                      )}
                    </Grid>

                    <Grid item xs={4}>
                      {!checkNotEmpty(profile?.work_image_fifth) ? (
                        <DropZone
                          onDrop={(files) => {
                            setProfile({
                              ...profile,
                              work_image_fifth: files[0],
                            });
                          }}
                          accept=".jpg, .jpeg, .png, .webp"
                        >
                          {(props) => {
                            return (
                              <ImageOtherEmpty
                                style={{
                                  userSelect: "none",
                                  cursor: "pointer",
                                  flexDirection: "column",
                                }}
                                {...props}
                              >
                                <InsertPhotoIcon
                                  sx={{
                                    color: "#BCBCC0",
                                    width: "25%",
                                    height: "25%",
                                  }}
                                />
                                <span
                                  style={{
                                    fontSize: "0.65rem",
                                    color: "#6C6C70",
                                  }}
                                >
                                  อัพโหลดรูปภาพ
                                </span>
                              </ImageOtherEmpty>
                            );
                          }}
                        </DropZone>
                      ) : (
                        <>
                          <WrapperOtherImage>
                            <div
                              style={{
                                position: "relative",
                                width: "100%",
                                height: "100%",
                                borderRadius: "16px",
                                overflow: "hidden",
                                marginBottom: "8px",
                              }}
                            >
                              <img
                                src={
                                  typeof profile?.work_image_fifth === "string"
                                    ? profile?.work_image_fifth
                                    : URL.createObjectURL(
                                        profile?.work_image_fifth,
                                      )
                                }
                                alt="work_image_fifth"
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  borderRadius: "16px",
                                  objectFit: "cover",
                                }}
                              />
                              <div
                                style={{
                                  position: "absolute",
                                  top: "10px",
                                  right: "10px",
                                  cursor: "pointer",
                                }}
                              >
                                <Delete
                                  onClick={(e) => {
                                    setProfile({
                                      ...profile,
                                      work_image_fifth: "",
                                    });
                                  }}
                                  sx={{
                                    background: "#fff",
                                    borderRadius: "100%",
                                    color: "#e04132",
                                    padding: "3px",
                                  }}
                                />
                              </div>
                            </div>
                          </WrapperOtherImage>
                        </>
                      )}
                    </Grid>

                    <Grid item xs={4}>
                      {!checkNotEmpty(profile?.work_image_sixth) ? (
                        <DropZone
                          onDrop={(files) => {
                            setProfile({
                              ...profile,
                              work_image_sixth: files[0],
                            });
                          }}
                          accept=".jpg, .jpeg, .png, .webp"
                        >
                          {(props) => {
                            return (
                              <ImageOtherEmpty
                                style={{
                                  userSelect: "none",
                                  cursor: "pointer",
                                  flexDirection: "column",
                                }}
                                {...props}
                              >
                                <InsertPhotoIcon
                                  sx={{
                                    color: "#BCBCC0",
                                    width: "25%",
                                    height: "25%",
                                  }}
                                />
                                <span
                                  style={{
                                    fontSize: "0.65rem",
                                    color: "#6C6C70",
                                  }}
                                >
                                  อัพโหลดรูปภาพ
                                </span>
                              </ImageOtherEmpty>
                            );
                          }}
                        </DropZone>
                      ) : (
                        <>
                          <WrapperOtherImage>
                            <div
                              style={{
                                position: "relative",
                                width: "100%",
                                height: "100%",
                                borderRadius: "16px",
                                overflow: "hidden",
                                marginBottom: "8px",
                              }}
                            >
                              <img
                                src={
                                  typeof profile?.work_image_sixth === "string"
                                    ? profile?.work_image_sixth
                                    : URL.createObjectURL(
                                        profile?.work_image_sixth,
                                      )
                                }
                                alt="work_image_sixth"
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  borderRadius: "16px",
                                  objectFit: "cover",
                                }}
                              />
                              <div
                                style={{
                                  position: "absolute",
                                  top: "10px",
                                  right: "10px",
                                  cursor: "pointer",
                                }}
                              >
                                <Delete
                                  onClick={(e) => {
                                    setProfile({
                                      ...profile,
                                      work_image_sixth: "",
                                    });
                                  }}
                                  sx={{
                                    background: "#fff",
                                    borderRadius: "100%",
                                    color: "#e04132",
                                    padding: "3px",
                                  }}
                                />
                              </div>
                            </div>
                          </WrapperOtherImage>
                        </>
                      )}
                    </Grid>
                  </Grid>
                </>
              ) : (
                <>
                  <Grid container spacing={2} sx={{ marginBottom: "24px" }}>
                    <Grid item xs={6}>
                      {!checkNotEmpty(profile?.banner_image) ? (
                        <ImageOtherEmpty>
                          <InsertPhotoIcon
                            sx={{
                              color: "rgba(0, 0, 0, 0.54)",
                              width: "25%",
                              height: "25%",
                            }}
                          />
                        </ImageOtherEmpty>
                      ) : (
                        <>
                          <WrapperOtherImage>
                            <img
                              src={profile?.banner_image}
                              alt={profile?.banner_image}
                              style={{
                                width: "100%",
                                height: "100%",
                                borderRadius: "16px",
                                objectFit: "cover",
                              }}
                            />
                          </WrapperOtherImage>
                        </>
                      )}
                    </Grid>

                    <Grid item xs={6}>
                      {!checkNotEmpty(profile?.work_image_first) ? (
                        <ImageOtherEmpty>
                          <InsertPhotoIcon
                            sx={{
                              color: "rgba(0, 0, 0, 0.54)",
                              width: "25%",
                              height: "25%",
                            }}
                          />
                        </ImageOtherEmpty>
                      ) : (
                        <>
                          <WrapperOtherImage>
                            <img
                              src={profile?.work_image_first}
                              alt={profile?.work_image_first}
                              style={{
                                width: "100%",
                                height: "100%",
                                borderRadius: "16px",
                                objectFit: "cover",
                              }}
                            />
                          </WrapperOtherImage>
                        </>
                      )}
                    </Grid>
                  </Grid>

                  <Grid container spacing={2} sx={{ marginBottom: "24px" }}>
                    <Grid item xs={6}>
                      {!checkNotEmpty(profile?.work_image_second) ? (
                        <ImageOtherEmpty>
                          <InsertPhotoIcon
                            sx={{
                              color: "rgba(0, 0, 0, 0.54)",
                              width: "25%",
                              height: "25%",
                            }}
                          />
                        </ImageOtherEmpty>
                      ) : (
                        <>
                          <WrapperOtherImage>
                            <img
                              src={profile?.work_image_second}
                              alt={profile?.work_image_second}
                              style={{
                                width: "100%",
                                height: "100%",
                                borderRadius: "16px",
                                objectFit: "cover",
                              }}
                            />
                          </WrapperOtherImage>
                        </>
                      )}
                    </Grid>

                    <Grid item xs={6}>
                      {!checkNotEmpty(profile?.work_image_third) ? (
                        <ImageOtherEmpty>
                          <InsertPhotoIcon
                            sx={{
                              color: "rgba(0, 0, 0, 0.54)",
                              width: "25%",
                              height: "25%",
                            }}
                          />
                        </ImageOtherEmpty>
                      ) : (
                        <>
                          <WrapperOtherImage>
                            <img
                              src={profile?.work_image_third}
                              alt={profile?.work_image_third}
                              style={{
                                width: "100%",
                                height: "100%",
                                borderRadius: "16px",
                                objectFit: "cover",
                              }}
                            />
                          </WrapperOtherImage>
                        </>
                      )}
                    </Grid>
                  </Grid>

                  <Grid container spacing={2} sx={{ marginBottom: "24px" }}>
                    <Grid item xs={4}>
                      {!checkNotEmpty(profile?.work_image_fourth) ? (
                        <ImageOtherEmpty>
                          <InsertPhotoIcon
                            sx={{
                              color: "rgba(0, 0, 0, 0.54)",
                              width: "25%",
                              height: "25%",
                            }}
                          />
                        </ImageOtherEmpty>
                      ) : (
                        <>
                          <WrapperOtherImage>
                            <img
                              src={profile?.work_image_fourth}
                              alt={profile?.work_image_fourth}
                              style={{
                                width: "100%",
                                height: "100%",
                                borderRadius: "16px",
                                objectFit: "cover",
                              }}
                            />
                          </WrapperOtherImage>
                        </>
                      )}
                    </Grid>

                    <Grid item xs={4}>
                      {!checkNotEmpty(profile?.work_image_fifth) ? (
                        <ImageOtherEmpty>
                          <InsertPhotoIcon
                            sx={{
                              color: "rgba(0, 0, 0, 0.54)",
                              width: "25%",
                              height: "25%",
                            }}
                          />
                        </ImageOtherEmpty>
                      ) : (
                        <>
                          <WrapperOtherImage>
                            <img
                              src={profile?.work_image_fifth}
                              alt={profile?.work_image_fifth}
                              style={{
                                width: "100%",
                                height: "100%",
                                borderRadius: "16px",
                                objectFit: "cover",
                              }}
                            />
                          </WrapperOtherImage>
                        </>
                      )}
                    </Grid>

                    <Grid item xs={4}>
                      {!checkNotEmpty(profile?.work_image_sixth) ? (
                        <ImageOtherEmpty>
                          <InsertPhotoIcon
                            sx={{
                              color: "rgba(0, 0, 0, 0.54)",
                              width: "25%",
                              height: "25%",
                            }}
                          />
                        </ImageOtherEmpty>
                      ) : (
                        <>
                          <WrapperOtherImage>
                            <img
                              src={profile?.work_image_sixth}
                              alt={profile?.work_image_sixth}
                              style={{
                                width: "100%",
                                height: "100%",
                                borderRadius: "16px",
                                objectFit: "cover",
                              }}
                            />
                          </WrapperOtherImage>
                        </>
                      )}
                    </Grid>
                  </Grid>
                </>
              )}
            </DivBackground>
          </Grid>
        </Grid>

        {isEdit && (
          <Grid
            container={isSmallerThanTablet ? false : true}
            spacing={4}
            sx={{ mt: 0, mb: 2 }}
          >
            <Grid
              item
              xs={6}
              sx={{
                margin: "auto",
                display: "flex",
                justifyContent: "center",
                gap: 2,
              }}
            >
              <StyledButton
                variant="outlined"
                sx={{ minWidth: 110 }}
                onClick={() => {
                  openDialog({
                    type: "confirm",
                    title: `คุณต้องการยกเลิกการแก้ไขใช่หรือไม่`,
                    onConfirm: () => {
                      setIsEdit(false);
                      closeDialog();
                    },
                    maxWidth: 342,
                  });
                }}
              >
                Cancel
              </StyledButton>
              <StyledButton
                variant="contained"
                sx={{ minWidth: 110 }}
                onClick={() => {
                  openDialog({
                    type: "confirm",
                    title: `คุณต้องการบันทึกการแก้ไขใช่หรือไม่`,
                    onConfirm: () => {
                      handleUpdate();
                      closeDialog();
                    },
                    maxWidth: 342,
                  });
                }}
              >
                Save
              </StyledButton>
            </Grid>
          </Grid>
        )}
      </Container>
    </Main>
  );
};

export default Profile;
